<template>
  <div class="p-3 bg-white card border-radius-xl mt-3 me-3" data-animation="FadeIn">
    <div class="row">
      <div class="form-group col-12 col-sm-4">
        <label class="required">{{ $t('contractName') }}</label>
        <input
          class="form-control"
          type="text"
          :placeholder="$t('contractName')"
          v-model="state.term.name"
          required
        />
      </div>
      <div class="form-group col-12 col-sm-4">
        <label class="required">{{ $t('contractStartDate') }}</label>
        <input
          class="form-control"
          type="text"
          :placeholder="$t('contractStartDate')"
          v-model="state.term.initial_date"
          v-maska="'##/##/####'"
          required
        />
      </div>
      <div class="form-group col-12 col-sm-4">
        <label class="required">{{ $t('contractEndDate') }}</label>
        <input
          class="form-control"
          type="text"
          :placeholder="$t('contractEndDate')"
          v-model="state.term.final_date"
          v-maska="'##/##/####'"
          required
        />
      </div>
      <div class="form-group col-12 col-sm-4">
        <label class="required">{{ $t('status') }}</label>
        <select
          class="form-control text-center custom-select"
          :disabled="state.statusOriginal === 'i'"
          v-model="state.term.status"
          required
        >
          <option value="a">{{ $t('active') }}</option>
          <option value="i">{{ $t('inactive') }}</option>
          <option value="d">{{ $t('draft') }}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-12">
        <label class="required">{{ $t('contractText') }}</label>
        <Editor
          api-key="c3pbj06iw6wid49ydqdu2wd42crd1p6f19ykut5pot19cf46"
          v-model="state.term.term_text"
          :init="{
            toolbar_mode: 'sliding',
            plugins:
              'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
            toolbar:
              'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
            tinycomments_mode: 'embedded',
          }"
          initial-value=""
        />
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-12 text-end">
        <button type="button" class="btn bg-gradient-secondary" @click.prevent="voltar">
          {{ $t('back') }}
        </button>
        <button type="button" class="ms-3 btn bg-gradient-primary" @click.prevent="salvar">
          {{ $t('save') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import alunoContratosRepository from '../../../../services/api/alunoContratosRepository'
import { inject, onMounted, reactive } from 'vue'
import { useI18n } from 'vue-i18n' // Import useI18n
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import Editor from '@tinymce/tinymce-vue'

export default {
  components: {
    Editor,
  },
  props: {
    termoIdProp: {
      type: Number,
      default: 0,
    },
  },
  setup(props, context) {
    const { t } = useI18n() // Initialize useI18n and get the `t` function
    const router = useRouter()
    const route = useRoute()
    const swal = inject('$swal')
    const store = useStore()

    onMounted(() => {
      store.commit('SET_SPLASH_SCREEN', false)
      if (props.termoIdProp > 0) {
        state.termoId = props.termoIdProp
        buscarDados()
      }
    })

    const state = reactive({
      termoId: 0,
      term: {
        status: 'd',
        name: '',
        term_text: '',
      },
      statusOriginal: '',
    })

    const buscarDados = () => {
      store.commit('SET_SPLASH_SCREEN', true)
      alunoContratosRepository
        .TermoGetById(state.termoId)
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)

          if (response.data.success) {
            state.statusOriginal = response.data.data['status']
            state.term = Object.assign({}, response.data.data)
            state.term.initial_date = state.term.initial_date.split('-').reverse().join('/')
            state.term.final_date = state.term.final_date.split('-').reverse().join('/')
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          swal({
            icon: 'error',
            title: t('errorFetchingContracts'), // Use translation
            text: error.message,
          })
        })
    }

    async function salvar() {
      if (state.statusOriginal == 'i' && state.term.status != 'i') {
        swal({
          text: t('cannotChangeInactiveContractStatus'), // Use translation
          icon: 'info',
          customClass: {
            confirmButton: 'btn bg-gradient-success',
          },
          buttonsStyling: false,
        })
        return
      }

      store.commit('SET_SPLASH_SCREEN', true)
      const term = {
        initial_date: state.term.initial_date.split('/').reverse().join('-'),
        final_date: state.term.final_date.split('/').reverse().join('-'),
        name: state.term.name,
        status: state.term.status,
        term_text: state.term.term_text,
      }
      if (state.termoId === 0) {
        alunoContratosRepository
          .TermoPost(term)
          .then((response) => {
            store.commit('SET_SPLASH_SCREEN', false)
            if (response.data.success) {
              swal({
                title: t('contract'), // Use translation
                text: t('contractCreatedSuccessfully'), // Use translation
                icon: 'success',
                customClass: {
                  confirmButton: 'btn bg-gradient-success',
                },
                buttonsStyling: false,
              }).then(() => {
                context.emit('fecharForm')
              })
            }
          })
          .catch((error) => {
            store.commit('SET_SPLASH_SCREEN', false)
            swal({
              icon: 'error',
              title: t('errorSavingContract'), // Use translation
              text: error.message,
            })
          })
      } else {
        alunoContratosRepository
          .TermoPut(state.termoId, term)
          .then((response) => {
            store.commit('SET_SPLASH_SCREEN', false)
            if (response.data.success) {
              swal({
                title: t('contract'), // Use translation
                text: t('contractUpdatedSuccessfully'), // Use translation
                icon: 'success',
                customClass: {
                  confirmButton: 'btn bg-gradient-success',
                },
                buttonsStyling: false,
              }).then(() => {
                context.emit('fecharForm')
              })
            }
          })
          .catch((error) => {
            store.commit('SET_SPLASH_SCREEN', false)
            swal({
              icon: 'error',
              title: t('errorUpdatingContract'), // Use translation
              text: error.message,
            })
          })
      }
    }

    function voltar() {
      context.emit('fecharForm')
    }

    return {
      state,
      salvar,
      voltar,
    }
  },
}
</script>

<style scoped></style>
